import store from './Store'
export default {
  store,
  install (Vue) {
    Vue.prototype.$store = store
  }
}